import { UniqueEntityID } from '@/domain/core'
import { UseCase } from '@/domain/core/UseCase'
import { UserGeometry } from '@/domain/models/UserGeometry/UserGeometry'
import { Result } from '@/domain/protocols/Result'

import type { IUserGeometryRepository } from '@/data/UserGeometryRepository/IUserGeometryRepository'

export class LoadUserGeometryUseCase implements UseCase<UniqueEntityID, Promise<Result<UserGeometry>>> {
  constructor(private readonly repository: IUserGeometryRepository) {}

  async execute(geometryId: UniqueEntityID): Promise<Result<UserGeometry>> {
    try {
      return await this.repository.getGeometry(geometryId)
    } catch (error) {
      return Result.fail(error)
    }
  }
}
